

import UsersManagement from "./UsersManagement";

const UsersCompliance = () => <UsersManagement variant="compliance" />;

export default UsersCompliance;